import "./OrSeparatorComponent.scss";
import {motion} from "framer-motion";



const containerVariants = {
    hidden: {opacity: 0, y: 20},
    visible: {opacity: 1, y: 0, transition: {duration: 0.5, ease: "easeInOut"}},
    exit: {opacity: 0, y: -20, transition: {duration: 0.3, ease: "easeInOut"}},
};

const OrSeparatorComponent = () => {

    return (
        <motion.div
            className="flex items-center justify-center gap-2 mb-3"
            variants={containerVariants}
        >
            <hr className="w-full h-[0.5px] border-0 left-line-gradient"/>
            <span className="px-2 text-xs">OR</span>
            <hr className="w-full h-[0.5px] border-0 right-line-gradient"/>
        </motion.div>
    );

};

export default OrSeparatorComponent;
